import script from "./HoroscopeTuneForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HoroscopeTuneForm.vue?vue&type=script&setup=true&lang=js"

import "./HoroscopeTuneForm.vue?vue&type=style&index=0&id=6305aaee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6305aaee"]])

export default __exports__